import { BreadcrumbItem } from '@/components/Breadcrumb/types'
import { BreadcrumbsFromHistory } from '../scheduled-types'

const routeLabelMap: Record<string, string> = {
  '/atendimento-agendado/especialidades': 'Especialidade',
  '/atendimento-agendado/preferencia/busca-profissional/':
    'Buscar pelo nome do profissional',
  '/atendimento-agendado/anexos': 'Anexos',
  '/atendimento-agendado/confirmar-dados': 'Dados',
  '/atendimento-agendado/preferencia/especialidades': 'Especialidade',
  '/atendimento-agendado/especialidade/busca/': 'Tipo de busca',
  '/atendimento-agendado/categoria': 'Data e Hora',
  '/atualizar-dados': 'Seus dados',
  '/atendimento-agendado-psicologo/perfil/': 'Data e Hora',
  '/atendimento-agendado-psicologo/busca-profissional/v2': 'Busca profissional',
  '/meus-atendimentos': 'Consultas',
  '/atendimento-agendado/especialidade/encaixe/': 'Encaixe',
  '/atendimento-agendado/busca-profissional-agenda/': 'Busca profissional',
  '/checkout/confirmar': 'Confirmar',
  '/': 'Início',
}

export const getBreadcrumbsFromHistory = ({
  history,
  logAnalyticsEvent,
  isMobile,
}: BreadcrumbsFromHistory): BreadcrumbItem[] => {
  const uniqueHistory = history
    ?.filter((route, index, self) => self?.indexOf(route) === index)
    .filter(route => !route.includes('/redirecionar'))
    .filter(route => !route.includes('/checkout/confirmar'))

  const breadcrumbs: BreadcrumbItem[] = [{ route: '/', label: 'Início' }]

  uniqueHistory
    .filter(route => route !== '/')
    .forEach(route => {
      const matchedKey = Object.keys(routeLabelMap).find(key =>
        route.startsWith(key),
      )
      const label = matchedKey ? routeLabelMap[matchedKey] : route
      const breadcrumb: BreadcrumbItem = {
        route,
        label,
        ...(isMobile &&
          logAnalyticsEvent && {
            onClick: () => logAnalyticsEvent('Pac_Agendada_Voltar'),
          }),
      }
      breadcrumbs.push(breadcrumb)
    })

  if (breadcrumbs.length > 0) {
    breadcrumbs.forEach((item, idx) => {
      if ('active' in item) delete item.active
      if (idx === breadcrumbs.length - 1) item.active = true
    })
  }

  return breadcrumbs
}
